import _ from 'lodash';
// eslint-disable-next-line import/no-cycle
import { types } from '../actions/appActions';
import initialState from './initialState';
import * as UserUtilities from '../HelperMethods/UserUtilities';
import { DEFAULT_ROLE, DEFAULT_VENDOR_ROLE } from '../HelperMethods/role-resource-constants';

const featureFlags = {
  feature1: false,
};
function getSelectedRunEngineSettings(runEngineSettings, field, areas) {
  const runEngineSettingsKey = areas.length === 1 ? areas[0].id : field.id;
  return runEngineSettings && runEngineSettings[runEngineSettingsKey];
}

function parseKeyValuesOfObject(obj, keys) {
  keys.forEach((key) => {
    if (obj[key] && typeof obj[key] === 'string') {
      obj[key] = JSON.parse(obj[key]);
    }
  });
  return obj;
}

const settingKeys = [
  'runEngineSettings',
  'featureFlags',
  'settings',
  'app',
  'common',
  'admin',
  'automateDailyRunSettings',
];

export function changeSelectedFilter(selectedFilter) {
  return { type: types.CHANGE_SELECTED_FILTER, selectedFilter };
}

export default function appReducer(state = initialState.appReducer, action) {
  switch (action.type) {
    case types.CHANGE_TEMP_FILTER: {
      const { tempFilter } = action;
      return {
        ...state,
        tempCreatedFilter: tempFilter,
      };
    }
    case types.SET_TENANT_ID:
      return { ...state, tenantId: action.tenantId };
    case types.FIELD_CHANGED: {
      const selectedField = action.field;
      const selectedAreas = [];
      const selectedRunEngineSettings = getSelectedRunEngineSettings(
        state.settings.runEngineSettings,
        selectedField,
        selectedAreas
      );
      return { ...state, selectedField, selectedAreas, selectedRunEngineSettings };
    }
    case types.AREAS_SELECTED: {
      const { areas } = action;
      const selectedRunEngineSettings = getSelectedRunEngineSettings(
        state.settings.runEngineSettings,
        state.selectedField,
        areas
      );
      return { ...state, selectedAreas: areas, selectedRunEngineSettings };
    }
    case types.LOAD_FIELDS_SUCCESS:
      return { ...state, fields: action.fields };
    case types.LOAD_TASKTYPE_GROUPS_SUCCESS:
      return { ...state, taskTypeGroups: action.taskTypeGroups };
    case types.SET_LOGGED_IN_USER: {
      const isUserVendor = UserUtilities.isUserVendor(action.user);
      const { user } = action;
      if (!user.roleObjects || user.roleObjects.length === 0) {
        user.roleObjects = [isUserVendor ? DEFAULT_VENDOR_ROLE : DEFAULT_ROLE];
      }
      return { ...state, loggedInUser: user };
    }
    case types.ROLE_UPDATED: {
      const { roleObject } = action;
      const { loggedInUser } = state;
      if (loggedInUser.joyn2Roles?.includes(roleObject.id)) {
        const clonedLoggedInUser = _.clone(loggedInUser);
        clonedLoggedInUser.roleObjects = [
          ...clonedLoggedInUser.roleObjects.filter((roleObj) => roleObj.id !== roleObject.id),
          roleObject,
        ];
        return { ...state, loggedInUser: clonedLoggedInUser };
      }
      return state;
    }
    case types.SETTINGS_UPDATED:
    case types.SETTINGS_LOADED: {
      action.data = parseKeyValuesOfObject(action.data, settingKeys);
      action.data.featureFlags = { ...action.data.featureFlags, ...featureFlags };

      const selectedRunEngineSettings = getSelectedRunEngineSettings(
        action.data.runEngineSettings,
        state.selectedField,
        state.selectedAreas
      );
      return { ...state, settings: action.data, selectedRunEngineSettings };
    }
    case types.PACKAGES_INFO_LOADED: {
      return { ...state, packagesInfo: action.data || {} };
    }
    case types.LOADING_INITIAL_DATA:
      return { ...state, isAppLoading: true };
    case types.HIDE_LOADER:
      return { ...state, isAppLoading: false };
    case types.SHOW_ERROR_MESSAGE:
      return { ...state, errorMessage: action.errorMessage };
    case types.SET_FIELDS_FOR_DROPDOWN:
      return { ...state, fieldsForDropdown: action.fields };
    case types.SET_AREAS_FOR_DROPDOWN:
      return { ...state, areasForDropdown: action.areas };
    case types.SET_ALL_AREAS:
      return { ...state, allAreas: action.areas };
    case types.SET_ALL_AREAS_USER_HAS_ACCESS_TO:
      return { ...state, allAreasUserHasAccessTo: action.allAreasUserHasAccessTo };
    case types.SET_TASKTYPE_GROUPS_FOR_DROPDOWN:
      return { ...state, taskTypeGroupsForDropdown: action.taskTypeGroups };
    case types.TASKTYPES_GROUPS_SELECTED:
      return { ...state, selectedTaskTypeGroups: action.taskTypeGroups };
    case types.CHANGE_SELECTED_FILTER: {
      const { selectedFilter } = action;
      return {
        ...state,
        selectedFilter,
      };
    }
    case types.UPSERT_AREAS: {
      const areaIds = action.updatedAreas.map((val) => val.id);
      return {
        ...state,
        allAreas: [...state.allAreas.filter((area) => !areaIds.includes(area.id)), ...action.updatedAreas],
      };
    }
    case types.SET_USER_CONFIG: {
      const { userConfig } = action;
      return {
        ...state,
        userConfig: userConfig || {},
      };
    }
    case types.SET_INITIAL_USER_CONFIG: {
      const { userConfig } = action;
      return {
        ...state,
        initialUserConfig: userConfig || {},
      };
    }
    case types.SET_TENANT_STATUS_CONFIG: {
      const { statusConfig } = action;
      return {
        ...state,
        statusConfig: statusConfig || {},
      };
    }
    case types.UPSERT_API_TRIGGER_LIST: {
      const { triggerAPIList = [] } = action;
      return {
        ...state,
        triggerAPIList,
      };
    }

    default:
      return state;
  }
}

export const getSelectedAreasForTaskViewPage = (state) => {
  const { areasForDropdown, selectedAreas } = state.appReducer;
  return selectedAreas.length > 0 ? selectedAreas : areasForDropdown;
};

export const getSelectedTaskTypeGroupsForTaskViewPage = (state) => {
  const { taskTypeGroupsForDropdown, selectedTaskTypeGroups, taskTypeGroups } = state.appReducer;
  const diffreneceInAccess = _.difference(
    taskTypeGroups.map((item) => item.id),
    taskTypeGroupsForDropdown.map((item) => item.id)
  );

  if (selectedTaskTypeGroups.length) {
    return selectedTaskTypeGroups;
  }

  return diffreneceInAccess.length ? taskTypeGroupsForDropdown : [];
};

export const getIsDRScoreEnabled = (state) => {
  return !!_.get(state, 'appReducer.settings.featureFlags.isDRScoreEnabled');
};

export const getAllFields = (state) => _.get(state, 'appReducer.fields');
